import { tx as translateInterfaceText } from '@/utils/i18n';
/**
 * Rótulos compartilhados dos slots do bloco de oferta.
 *
 * Conteúdo e Estilo editam propriedades diferentes do MESMO slot (tamanho de um
 * lado, cor e espessura do outro). Com uma tabela de rótulos em cada card, basta
 * uma edição para um dizer "Preço principal" e o outro "Preço" — daí a fonte
 * única aqui.
 */

import type { ActionButtonSlot } from '@/lib/action-button';

/** Slots textuais do bloco. Slot fora desta tabela não é textual. */
export const TEXT_SLOT_LABELS = {
  get urgency() { return translateInterfaceText("Faixa de urgência"); },
  headline: 'Headline',
  get subheadline() { return translateInterfaceText("Subtítulo"); },
  get offerText() { return translateInterfaceText("Chamada da oferta"); },
  get strikethrough() { return translateInterfaceText("Preço riscado"); },
  get featured() { return translateInterfaceText("Preço em destaque"); },
  get price() { return translateInterfaceText("Preço principal"); },
  get priceNote() { return translateInterfaceText("Condição secundária"); },
} as const;

export type TextSlot = keyof typeof TEXT_SLOT_LABELS;

/** Slots textuais que o usuário pode ligar/desligar. */
export const TOGGLEABLE_SLOTS: TextSlot[] = ['urgency', 'strikethrough'];

/** Predicado: estreita um slot do layout para os slots textuais. */
export function isTextSlot(slot: ActionButtonSlot): slot is TextSlot {
  return slot in TEXT_SLOT_LABELS;
}

/**
 * Título da seção do segundo caminho. Depende da FORMA (botão ou link), não do
 * modelo: dois botões são duas opções de mesmo peso, um link é uma recusa.
 */
export function secondarySectionLabel(renderAs: 'button' | 'link'): string {
  return renderAs === 'button' ? translateInterfaceText("Segunda opção") : translateInterfaceText("Opção de recusa");
}
